module.exports = __webpack_public_path__ + "static/media/expertentelefon_avacon.af7fe09c.svg";